import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../contexts/NotificationContext";

const typeIcon = {
  info: "pi pi-info-circle",
  success: "pi pi-check-circle",
  warning: "pi pi-exclamation-triangle",
  error: "pi pi-times-circle",
};

const typeColor = {
  info: "#3b82f6",
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
};

function timeAgo(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  return `${d}d`;
}

const NotificationDropdown = ({ onClose }) => {
  const navigate = useNavigate();
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();

  const latest = notifications.slice(0, 10);

  const handleClick = async (n) => {
    if (!n.is_read) await markAsRead(n.id);
    if (n.link) navigate(n.link);
    if (onClose) onClose();
  };

  const handleViewAll = () => {
    navigate("/index/notifications");
    if (onClose) onClose();
  };

  return (
    <div className="notification-dropdown">
      <div
        className="notification-dropdown-header flex justify-content-between align-items-center"
        style={{
          padding: "0.5rem 0.75rem",
          borderBottom: "1px solid var(--app-border)",
        }}
      >
        <strong style={{ color: "var(--app-text)" }}>
          Notifications {unreadCount > 0 ? `(${unreadCount})` : ""}
        </strong>
        {unreadCount > 0 && (
          <Button
            label="Mark all read"
            className="p-button-text p-button-sm"
            onClick={markAllAsRead}
          />
        )}
      </div>

      <div
        className="notification-dropdown-list"
        style={{ maxHeight: "400px", overflowY: "auto" }}
      >
        {latest.length === 0 ? (
          <div
            style={{
              padding: "1.5rem",
              textAlign: "center",
              color: "var(--app-text-secondary)",
            }}
          >
            <i className="pi pi-inbox" style={{ fontSize: "2rem", opacity: 0.5 }} />
            <div style={{ marginTop: "0.5rem" }}>No notifications</div>
          </div>
        ) : (
          latest.map((n) => (
            <div
              key={n.id}
              onClick={() => handleClick(n)}
              style={{
                padding: "0.75rem",
                borderBottom: "1px solid var(--app-border)",
                cursor: "pointer",
                display: "flex",
                gap: "0.75rem",
                background: n.is_read ? "transparent" : "var(--app-hover-bg)",
              }}
              className="notification-item"
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: typeColor[n.type] || typeColor.info,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <i className={typeIcon[n.type] || typeIcon.info} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontWeight: n.is_read ? 400 : 600,
                    color: "var(--app-text)",
                    fontSize: "0.9rem",
                  }}
                >
                  {n.title}
                </div>
                {n.body && (
                  <div
                    style={{
                      color: "var(--app-text-secondary)",
                      fontSize: "0.8rem",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {n.body}
                  </div>
                )}
                <div
                  style={{
                    color: "var(--app-text-secondary)",
                    fontSize: "0.75rem",
                    marginTop: "0.25rem",
                  }}
                >
                  {timeAgo(n.createdAt)} ago
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <div
        className="notification-dropdown-footer"
        style={{
          padding: "0.5rem",
          borderTop: "1px solid var(--app-border)",
          textAlign: "center",
        }}
      >
        <Button
          label="View all notifications"
          className="p-button-text p-button-sm"
          onClick={handleViewAll}
        />
      </div>
    </div>
  );
};

export default NotificationDropdown;
